/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_No_Connect_FlowInputs */



/**
* | output |
* | --- |
* | "This integration is configured by an administrator and needs nothing from you here." |
*
* @param {My_Integrations_Wizard_No_Connect_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_no_connect_flow = /** @type {((inputs?: My_Integrations_Wizard_No_Connect_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_No_Connect_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Integration wird von einem Administrator konfiguriert und erfordert hier nichts von Ihnen.")
	return /** @type {LocalizedString} */ ("This integration is configured by an administrator and needs nothing from you here.")
});